import React from "react";

const EnergoPagination = ({ max, current, select }) => {

    return (
        <ul className="list-vertical" style={{minHeight: 44}}>
            {current > 1 ? <li className="link-energo" onClick={e => { e.preventDefault(); select(current - 1) }}>vorherige</li> : null}
            {current > 1 && (current - 1) !== 1 ? <li onClick={() => select(1)} className="link-energo">1</li> : null}
            {current > 3 ? <li className="no-style">...</li> : null}
            {current > 1 ? <li onClick={() => select(current -1)} className="link-energo">{current - 1}</li> : null}

            {max > 1 ? <li className="list-vertical-selected">{current}</li> : null}

            {max > (current + 1) ? <li onClick={() => select(current +1)} className="link-energo">{current + 1}</li> : null}
            {max > (current + 2) ? <li className="no-style">...</li> : null}
            {current < max ? <li onClick={() => select(max)} className="link-energo">{max}</li> : null}
            {current < max ? <li className="link-energo" onClick={e => { e.preventDefault(); select(current + 1) }}>nächste</li> : null}
        </ul>
    )
}
export default EnergoPagination;